/* eslint-disable import/prefer-default-export */
const prefix = 'forms/sign_in'

export const SET_FORM_VALUES = `${prefix}/SET_FORM_VALUES`
